import LegalPage from "./LegalPage";

export default function RefundPolicy() {
  return (
    <LegalPage
      testid="refund-policy-page"
      title="Refund Policy"
      updated="December 2025"
      sections={[
        {
          heading: "1. Overview",
          body: [
            "This Refund Policy outlines the terms under which TelstraNics ('we', 'us', or 'our') will consider refunds for services purchased from us. By engaging our services, you agree to the terms of this policy.",
          ],
        },
        {
          heading: "2. Eligible Refund Scenarios",
          body: ["You may request a refund in the following situations:"],
          list: [
            "Cancellation within 48 hours of initial payment for one-time projects, before any work has commenced.",
            "Failure by TelstraNics to deliver the agreed scope within the timelines set in the Statement of Work, provided no fault of the client caused the delay.",
            "Duplicate payments or billing errors caused by our systems.",
          ],
        },
        {
          heading: "3. Non-Refundable Items",
          body: ["The following are not eligible for refunds:"],
          list: [
            "Work already completed or in progress at the time of the refund request.",
            "Discovery and consultation fees, once services have been rendered.",
            "Third-party software, hosting, domain, or license costs incurred on your behalf.",
            "Monthly retainer fees for the current billing cycle, once the cycle has begun.",
          ],
        },
        {
          heading: "4. How to Request a Refund",
          body: [
            "To request a refund, email refunds@telstranics.com within 7 days of the qualifying event with your invoice number, project details, and reason for the request. Our team will review and respond within 5 business days.",
          ],
        },
        {
          heading: "5. Processing",
          body: [
            "Approved refunds are processed to the original payment method within 7–14 business days. Chargebacks initiated without following the process above may result in immediate suspension of services.",
          ],
        },
        {
          heading: "6. Changes to This Policy",
          body: ["We may update this policy from time to time. Continued use of our services after changes are posted constitutes acceptance of the updated policy."],
        },
      ]}
    />
  );
}
